var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoop = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 9.6667H10.2584L10.025 9.4417C11.025 8.27503 11.5417 6.68337 11.2584 4.9917C10.8667 2.67503 8.93337 0.825033 6.60003 0.5417C3.07503 0.108366 0.108366 3.07503 0.5417 6.60003C0.825033 8.93337 2.67503 10.8667 4.9917 11.2584C6.68337 11.5417 8.27503 11.025 9.4417 10.025L9.6667 10.2584V10.9167L13.2084 14.4584C13.55 14.8 14.1084 14.8 14.45 14.4584C14.7917 14.1167 14.7917 13.5584 14.45 13.2167L10.9167 9.6667ZM5.9167 9.6667C3.8417 9.6667 2.1667 7.9917 2.1667 5.9167C2.1667 3.8417 3.8417 2.1667 5.9167 2.1667C7.9917 2.1667 9.6667 3.8417 9.6667 5.9167C9.6667 7.9917 7.9917 9.6667 5.9167 9.6667Z",
    fill: "white",
    fillOpacity: 0.7
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loop.eb1e0a12.svg";
export { ForwardRef as ReactComponent };